export default {
    computedOrders () {
        // Removes orders not linked to travel.
        this.orders = this.orders.filter(order => order.trip)

        return this.orders.map(order => {
            return {
                ...order,
                agencyName: order.trip.agency.name ?? ''
            }
        })
    }
}
